export default {
  plaid: {
    dev: {
      env: 'sandbox',
      public_key: 'dbaef5e48f1ccc027c209c029ef395',
      products: ['auth'/*, 'transactions'*/],
    },
    prod: {
      env: 'production',
      public_key: '7a6c7c5803418fb705f19fde7e9204',
      products: ['auth']
    }
  }
}